"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group 312"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6.71528 0.0671814C6.89443 -0.0223938 7.1053 -0.0223938 7.28445 0.0671814L13.648 3.24894C13.8635 3.35673 13.9997 3.57707 13.9997 3.81811C13.9997 4.05914 13.8635 4.27948 13.648 4.38728L7.28445 7.56903C7.1053 7.6586 6.89443 7.6586 6.71528 7.56903L0.351766 4.38728C0.136181 4.27948 0 4.05914 0 3.81811C0 3.57707 0.136181 3.35673 0.351766 3.24894L6.71528 0.0671814ZM2.05928 3.81811L6.99986 6.2884L11.9404 3.81811L6.99986 1.34781L2.05928 3.81811Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.0673207 9.89683C0.224493 9.58248 0.606731 9.45507 0.921075 9.61224L7 12.6517L13.0789 9.61224C13.3933 9.45507 13.7755 9.58248 13.9327 9.89683C14.0899 10.2112 13.9624 10.5934 13.6481 10.7506L7.28458 13.9323C7.10543 14.0219 6.89457 14.0219 6.71542 13.9323L0.351906 10.7506C0.0375619 10.5934 -0.0898511 10.2112 0.0673207 9.89683Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.0673207 6.71519C0.224493 6.40084 0.606731 6.27343 0.921075 6.4306L7 9.47006L13.0789 6.4306C13.3933 6.27343 13.7755 6.40084 13.9327 6.71519C14.0899 7.02953 13.9624 7.41177 13.6481 7.56894L7.28458 10.7507C7.10543 10.8403 6.89457 10.8403 6.71542 10.7507L0.351906 7.56894C0.0375619 7.41177 -0.0898511 7.02953 0.0673207 6.71519Z",
    fill: fill
  })));
};

exports["default"] = _default;